"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Avatar_1 = tslib_1.__importDefault(require("@mui/material/Avatar"));
const stringToAvatarLetters_1 = require("../_InternalUtils/stringToAvatarLetters");
const styles_1 = require("./styles");
function AvatarContent(props) {
    const { alt, size, icon, color = "light", ...rest } = props;
    const initials = (0, stringToAvatarLetters_1.stringToAvatarLetters)(alt || "");
    return (react_1.default.createElement(Avatar_1.default, { sx: theme => Object.assign({
            backgroundColor: color === "light" ? theme.palette.primary.contrastText : theme.palette.text.primary,
            color: color === "light" ? theme.palette.text.primary : theme.palette.primary.contrastText,
            fill: color === "light" ? theme.palette.text.primary : theme.palette.primary.contrastText,
        }, size === "large" && { fontSize: 30 }, size === "extraLarge" && { fontSize: 40 }, styles_1.CONTAINER_SIZES[size]), ...rest },
        icon
            ? react_1.default.cloneElement(icon, {
                sx: theme => Object.assign({
                    fill: color === "light" ? theme.palette.text.primary : theme.palette.primary.contrastText,
                }, size === "large" && { width: theme.spacing(5), height: theme.spacing(5) }, size === "extraLarge" && { width: theme.spacing(8), height: theme.spacing(8) }),
            }) : null,
        !icon && initials));
}
exports.default = AvatarContent;
